const alarm = typeof window !== 'undefined' ? new Audio('/emergency-alarm.wav') : null;

export const playEmergencySound = () => {
  if (!alarm) return;
  alarm.currentTime = 0;
  alarm.play().catch(() => {});
};
